module.exports = __webpack_public_path__ + "img/welding-5.42b86e90.jpg";